import type { DocumentTableState } from "./useDocumentTableState";

function emptyTable({
  displayDocuments,
  folders,
  containerFiles,
  showLoadingOverlay,
}: DocumentTableState) {
  // The folder view's own refresh state controls its empty placeholder.
  return (
    displayDocuments.length === 0 &&
    folders.length === 0 &&
    containerFiles.length === 0 &&
    !showLoadingOverlay
  );
}
function selectionToolbar({
  showCheckbox,
  store,
  hideBulkActionBar,
  selectedFolderIds,
}: DocumentTableState) {
  return (
    showCheckbox &&
    !!store &&
    !hideBulkActionBar &&
    store.selectedCount + selectedFolderIds.length > 0
  );
}
function tableMinimumWidth({ rowArea, showStatus, showTags, showParent }: DocumentTableState) {
  // Retain the widest layout's old floor until width measurement is available.
  return rowArea.width === 0 && showStatus && showTags && showParent ? "min-w-[1000px]" : "";
}
export function documentTableRenderFlags(props: DocumentTableState) {
  return {
    isEmpty: emptyTable(props),
    selectionToolbarOpen: selectionToolbar(props),
    minWidth: tableMinimumWidth(props),
  };
}
export type DocumentTablePresentation = DocumentTableState &
  ReturnType<typeof documentTableRenderFlags>;
